<template>
		<div id="login">
				<div class="bgrt"></div>
				<div class="loginWrap">
						<div class="loginCont">
								<div class="ltcont">
										<div>
												<img src="./logo.png">
												<span class="sp1">欢迎使用 律金汇律师工作平台</span>
												<span class="sp2">打造业界一流服务平台</span>
												<span class="sp3">人性化全面实用</span>
												<span class="sp4">方便快捷高效</span>
										</div>
								</div>
								<div class="rtcont">
										<div class="rt">
												<div class="box1">
														<div class="tab">
																<button :class="loginType==1?'ckd':''" @click="changeTab(1)">密码登录</button>
																<button :class="loginType==2?'ckd':''" @click="changeTab(2)" style="float:right">手机登录
																</button>
														</div>
														<ul class="contTypes">
																<li v-if="loginType==1">
																		<div class="inputWrap normal" :class="focusList1?'focus':''">
																				<input type="" name="" placeholder="用户名" class="name" @focus="focusEvt1" @blur="blurEvt1" v-model="nameVal">
																				<img src="./name.png" class="icn">
																		</div>
																		<div class="inputWrap normal" :class="focusList2?'focus':''">
																				<input type="password" name="" placeholder="密码" class="pwd" @focus="focusEvt2" @blur="blurEvt2" v-model="pwdVal">
																				<img src="./lock.png" class="icn">
																		</div>
																		<div class="inputWrap">
																				<input type="" name="" placeholder="验证码" class="yzm1 normal" @focus="focusEvt3" @blur="blurEvt3" :class="focusList3?'focus':''" v-model="yzmVal1">
																				<div class="yzmWrap">
																						<img :src="yzmUrlNew" @click="refreshYzm">
																				</div>
																		</div>
																		<span class="check" v-if="!wrong1" @click='follow'>
																				<label id="labelId" v-if="!this.isFollow">
																					
																				</label>
																				<label v-if="this.isFollow" id="labelself">
																					
																				</label>
																				&nbsp;记住密码
																		</span>
																		<span class="wrong" v-if="wrong1">{{wrongcont1}}</span>
																		<input type="button" value="登录" class="login" @click="loginByname" @keyup.enter="loginByname">
																</li>
																<li v-if="loginType==2">
																		<div class="inputWrap normal" :class="focusList4?'focus':''">
																				<input type="" name="" placeholder="手机号" class="tel" @focus="focusEvt4" @blur="blurEvt4" v-model="telVal">
																				<img src="./phone.png" class="icn">
																		</div>
																		<div class="inputWrap normal" :class="focusList5?'focus':''">
																				<input type="" name="" placeholder="短信验证码" class="yzm2" @focus="focusEvt5" @blur="blurEvt5" v-model="yzmVal2">
																				<span @click="sendYzm">{{sendyzmCont}}</span>
																		</div>
																		<span class="wrong" v-if="wrong2">{{wrongcont2}}</span>
																		<input type="button" value="登录" class="login" @click="loginBytel" @keyup.enter="loginEnter($event)">
																
																</li>
														</ul>
												</div>
												<div class="box2">
														<span>联系客服：010-60608644</span>
														<span>Copyright &copy; 2016-2022 北京律金汇科技有限公司</span>
												</div>
										</div>
								</div>
						</div>
				</div>
				<loading :loadCont="loadingCont" v-if="isShowLoading"></loading>
				<div id="isLow" v-if="isIELow"></div>
		</div>
</template>
<script>
		import dataUrl from '../../../static/js/urls.json'
		import bus from '../../bus'
		import loading from '@/components/loading/loading'
		
		export default {
				components: {
						loading
				},
				data() {
						return {
								isShowLoading: false,//是否显示loading
								loadingCont: '正在登录',//loading的内容
								loginType: 1,
								focusList1: false,
								focusList2: false,
								focusList3: false,
								focusList4: false,
								focusList5: false,
								nameVal: '',
								pwdVal: '',
								yzmVal1: '',
								telVal: '',
								yzmVal2: '',
								wrong1: false,
								wrong2: false,
								wrongcont1: '',
								wrongcont2: '',
								sendyzmCont: '发送验证码',
								yzmUrl: '',
								yzmUrlNew: '',
								isIELow: false,//低版本浏览器
								isFollow: true//是否记住密码 true不记录false记录
						}
				},
				methods: {
						//记住密码
						follow() {
								this.isFollow = !this.isFollow;
						},
						//手机登录与电话登录切换
						changeTab(i) {
								var that = this
								if (!this.getCookie('username') && !this.getCookie('password')) {
										that.nameVal = ''
										that.pwdVal = ''
								}
								this.loginType = i
								this.yzmVal1 = ''
								this.telVal = ''
								this.yzmVal2 = ''
								this.wrong1 = false
								this.wrong2 = false
						},
						focusEvt1() {
								this.focusList1 = true
								this.wrong1 = false
						},
						blurEvt1() {
								this.focusList1 = false
								
						},
						focusEvt2() {
								this.focusList2 = true
								this.wrong1 = false
						},
						blurEvt2() {
								
								this.focusList2 = false
								
						},
						focusEvt3() {
								this.focusList3 = true
								this.wrong1 = false
						},
						blurEvt3() {
								
								this.focusList3 = false
								
						},
						focusEvt4() {
								this.focusList4 = true
								this.wrong2 = false
						},
						blurEvt4() {
								this.focusList4 = false
						},
						focusEvt5() {
								this.focusList5 = true
								this.wrong2 = false
						},
						blurEvt5() {
								this.focusList5 = false
						},
						loginEnter(e) {
								//console.log(e.keyCode)
						},
						loginByname() {
								if (this.nameVal === '') {
										this.wrong1 = true
										this.wrongcont1 = "请填写用户名"
								} else if (this.pwdVal === '') {
										this.wrong1 = true
										this.wrongcont1 = "请填写密码"
								} else if (this.yzmVal1 === '') {
										this.wrong1 = true
										this.wrongcont1 = "请填写验证码"
										this.refreshYzm()
								} else {
										this.isShowLoading = true
										var that = this
										var url = dataUrl.url + '/login'
										var params = new FormData()
										params.append('verify', that.yzmVal1)
										params.append('username', that.nameVal)
										params.append('password', that.pwdVal)
										this.$axios.post(url, params).then(function (res) {
											console.log(res)
												var code = res.data.code
												if (code == 200) {
														that.isShowLoading = false
														var getdata = res.data.data
														sessionStorage.setItem("verify", that.yzmVal1)
														sessionStorage.setItem("username", that.nameVal)
														sessionStorage.setItem("password", that.pwdVal)
														sessionStorage.setItem("infoid", getdata.infoid)
														sessionStorage.setItem("userid", getdata.userid)
														sessionStorage.setItem("username", getdata.username)
														sessionStorage.setItem("backdata", JSON.stringify(getdata))
														sessionStorage.setItem("user_identity",getdata.user_identity)
														that.setCookie('token', getdata.sessionid)
														//记住密码
														if (that.isFollow == false) {
																that.setCookie('username', that.nameVal, 86400000 * 30)
																that.setCookie('password', that.pwdVal, 86400000 * 30)
														}
														//that.loginHX(that.nameVal)
														that.$router.push({path: '/index'})
												} else {
														that.isShowLoading = false
														that.wrong1 = true
														that.wrongcont1 = res.data.msg
														that.refreshYzm()
												}
										})
								}
						},
						loginBytel() {
								if (this.telVal === '') {
										this.wrong2 = true
										this.wrongcont2 = "请填写手机号码"
								} else if (this.yzmVal2 === '') {
										this.wrong2 = true
										this.wrongcont2 = "请填写验证码"
								} else {
										this.isShowLoading = true
										var that = this
										var url = dataUrl.url + '/loginsms'
										var params = new FormData()
										params.append('phone', that.telVal)
										params.append('code', that.yzmVal2)
										this.$axios.post(url, params).then(function (res) {
												var code = res.data.code
												if (code == 200) {
														that.isShowLoading = false
														var getdata = res.data.data
														sessionStorage.setItem("username", getdata.username)
														sessionStorage.setItem("infoid", getdata.infoid)
														sessionStorage.setItem("userid", getdata.userid)
														sessionStorage.setItem("backdata", JSON.stringify(getdata))
														sessionStorage.setItem("user_identity",getdata.user_identity)
														that.setCookie('token', getdata.sessionid)
														that.$router.push({path: '/index'})
												} else {
														that.isShowLoading = false
														that.wrong2 = true
														that.wrongcont2 = res.data.msg
												}
										})
								}
						},
						sendYzm() {
								var partten = /^1[3578][0-9]{9}$/
								if (this.telVal == "" || !partten.test(this.telVal)) {
										this.wrong2 = true
										this.wrongcont2 = "请填写手机号码"
								} else {
										if (this.sendyzmCont === '发送验证码') {
												var that = this
												var url = dataUrl.url + '/ajaxsms'
												var params = new FormData()
												params.append('phone', that.telVal)
												this.$axios.post(url, params).then(function (res) {
														var code = res.data.code
														if (code !== 200) {
																that.wrong2 = true
																that.wrongcont2 = res.data.msg
														} else {
																var timer = null
																var seconds = 60
																timer = setInterval(function () {
																		seconds = seconds - 1
																		that.sendyzmCont = seconds + 's后发送'
																		if (seconds == 0) {
																				clearInterval(timer)
																				that.sendyzmCont = '发送验证码'
																		}
																}, 1000)
														}
												})
										}
								}
						},
						//刷新验证码
						refreshYzm() {
								this.yzmUrlNew = dataUrl.url + '/verify' + '?' + Math.random()
								
						},
						myBrowser() {
								
								var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
								var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
								var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
								var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
								if (isIE) {
										var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
										reIE.test(userAgent);
										var fIEVersion = parseFloat(RegExp["$1"]);
										if (fIEVersion == 7) {
												this.isIELow = true
										} else if (fIEVersion == 8) {
												this.isIELow = true
										} else if (fIEVersion == 9) {
												this.isIELow = true
										} else if (fIEVersion == 10) {
												this.isIELow = false
										} else {
												this.isIELow = true
										}
								} else if (isEdge) {
										this.isIELow = false
								} else if (isIE11) {
										this.isIELow = false
								} else {
										this.isIELow = false
								}
						}
				},
				mounted() {
						//this.setH()
						//this.browserRedirect()
						this.yzmUrlNew = dataUrl.url + '/verify';
						var that = this
						if (this.getCookie('username') && this.getCookie('password')) {
								that.nameVal = unescape(this.getCookie('username'))
								that.pwdVal = unescape(this.getCookie('password'))
						} else {
								that.isFollow = false
						}
						this.myBrowser()
				},
				created() {
						var lett = this;
						document.onkeydown = function (e) {
								var key = window.event.keyCode;
								if (key == 13) {
										lett.loginByname();
								}
						}
				}
		}
</script>
<style>
		#login {
				width: 100%;
				height: 100%;
				background: #f7f7f7;
				overflow: auto;
				position: relative;
		}
		
		#login .bgrt {
				width: 50%;
				height: 100%;
				background: #1569b8;
				float: right;
		}
		
		#login .loginWrap {
				width: 100%;
				height: 100%;
				background: url(./bg.png) no-repeat center top;
				background-size: auto 100%;
				z-index: 100;
				position: absolute;
				left: 0;
				top: 0;
		}
		
		#login .loginCont {
				width: 904px;
				height: 100%;
				margin: 0 auto;
		}
		
		#login .loginCont .ltcont {
				width: 452px;
				height: 100%;
				float: left;
				position: relative;
		}
		
		#login .loginCont .ltcont div {
				width: 100%;
				height: 320px;
				position: absolute;
				left: 0;
				top: 50%;
				margin-top: -160px;
		}
		
		#login .loginCont .ltcont div img, #login .loginCont .ltcont div span {
				float: left;
		}
		
		#login .loginCont .ltcont div img {
				margin-bottom: 31px;
				width: 306px;
		}
		
		#login .loginCont .ltcont div span {
				width: 100%;
				height: 30px;
				line-height: 30px;
				margin-bottom: 20px;
				font-size: 18px;
				color: #025db3;
				padding-left: 30px;
				box-sizing: border-box;
		}
		
		#login .loginCont .ltcont div span.sp1 {
				color: #6f7a81;
				padding-left: 0;
		}
		
		#login .loginCont .ltcont div span.sp2 {
				background: url(./confirm.png) no-repeat left center;
				background-size: 21px;
		}
		
		#login .loginCont .ltcont div span.sp3 {
				background: url(./total.png) no-repeat left center;
				background-size: 21px;
		}
		
		#login .loginCont .ltcont div span.sp4 {
				background: url(./rocket.png) no-repeat left center;
				margin-bottom: 0;
				background-size: 21px;
		}
		
		#login .loginCont .rtcont {
				width: 452px;
				height: 100%;
				float: left;
				position: relative;
		}
		
		#login .loginCont .rtcont .rt {
				width: 354px;
				height: 480px;
				position: absolute;
				right: 0;
				top: 50%;
				margin-top: -200px;
		}
		
		#login .loginCont .rtcont .rt .box1 {
				width: 100%;
				height: 389px;
				background: #ffffff;
				border-radius: 8px;
				box-shadow: 0 -22px 14px 0 rgba(2, 93, 179, 0.37);
				overflow: hidden;
		}
		
		#login .loginCont .rtcont .rt .box1 .tab {
				width: 100%;
				height: 60px;
		}
		
		#login .loginCont .rtcont .rt .box1 .tab button {
				width: 49%;
				height: 60px;
				line-height: 60px;
				font-size: 16px;
				color: #666666;
				float: left;
				background: #ffffff;
				box-shadow: 0 0 12px 0 rgba(74, 144, 226, 0.29);
		}
		
		#login .loginCont .rtcont .rt .box1 .tab button.ckd {
				box-shadow: none;
				color: #025db3;
				font-weight: bold;
		}
		
		#login .loginCont .rtcont .rt .box1 .contTypes {
				width: 100%;
				height: auto;
				overflow: hidden;
		}
		
		#login .loginCont .rtcont .rt .box1 .contTypes li {
				width: 100%;
				height: 329px;
				position: relative;
		}
		
		#login .loginCont .rtcont .rt .box1 .contTypes li .inputWrap {
				width: 320px;
				height: 52px;
				margin-top: 20px;
				margin-left: 17px;
				position: relative;
				float: left;
				box-sizing: border-box;
				
		}
		
		#login .contTypes li .inputWrap input {
				width: 100%;
				height: 52px;
				line-height: 52px;
				float: left;
				background: none;
				padding-left: 15px;
				padding-right: 45px;
				box-sizing: border-box;
				font-size: 16px;
				color: #454749;
		}
		
		#login .contTypes li .inputWrap input.yzm1 {
				width: 152px;
		}
		
		#login .contTypes li .inputWrap .yzmWrap {
				width: 152px;
				height: 52px;
				background: #f3fbfe;
				float: left;
				margin-left: 16px;
		}
		
		#login .contTypes li .inputWrap .yzmWrap img {
				width: 152px;
				height: 52px;
				cursor: pointer;
		}
		
		#login .contTypes li .inputWrap input.yzm2 {
				padding-right: 100px;
		}
		
		.normal {
				background: #f5f8f9;
				border-radius: 6px;
				border: 1px solid #f5f8f9;
		}
		
		#login .contTypes li .inputWrap input.normal {
				background: #f5f8f9;
				border-radius: 6px;
				padding-right: 15px;
				border: 1px solid #f5f8f9;
		}
		
		.focus {
				background: #fcfcfd;
				border: 1px solid #cde1f1;
				box-shadow: 0 2px 4px 0 #e9f4fd;
				border-radius: 6px;
				box-sizing: border-box;
		}
		
		#login .contTypes li .inputWrap input.focus {
				background: #fcfcfd;
				border: 1px solid #cde1f1;
				box-shadow: 0 2px 4px 0 #e9f4fd;
				border-radius: 6px;
				box-sizing: border-box;
		}
		
		#login .contTypes li .inputWrap .icn {
				position: absolute;
				right: 14px;
				top: 14px;
				width: 25px;
		}
		
		#login .contTypes li .inputWrap span {
				position: absolute;
				right: 14px;
				top: 14px;
				font-size: 16px;
				color: #025db3;
				cursor: pointer;
		}
		
		#login .contTypes li .wrong {
				width: 290px;
				min-height: 20px;
				line-height: 20px;
				padding-left: 28px;
				background: url(./prompt.png) no-repeat left 2px;
				background-size: 18px;
				display: block;
				font-size: 14px;
				color: #ff7777;
				position: absolute;
				left: 17px;
				bottom:72px;
		}
		
		#login .contTypes li .login {
				width: 320px;
				height: 50px;
				line-height: 50px;
				font-size: 14px;
				background: #025db3;
				border-radius: 4px;
				position: absolute;
				left: 17px;
				bottom: 17px;
				font-size: 18px;
				color: #ffffff
		}
		
		#login .loginCont .rtcont .rt .box2 {
				width: 100%;
				height: auto;
				overflow: hidden;
				padding-top: 12px;
		}
		
		#login .loginCont .rtcont .rt .box2 span {
				float: left;
				width: 100%;
				text-align: center;
				font-size: 13px;
				color: #ffffff;
				opacity: 0.8;
				line-height: 24px;
		}
		
		#isLow {
				width: 100%;
				height: 100%;
				background: #3cbbdc url(./browser.png) no-repeat center center;
				position: fixed;
				left: 0;
				top: 0;
				z-index: 100;
		}
		
		.check {
				min-height: 20px;
				line-height: 20px;
				display: block;
				font-size: 14px;
				color: #666666;
				position: absolute;
				left: 24px;
				bottom: 83px;
				cursor: pointer;
		}
		
		#labelself {
				width: 16px;
				height: 16px;
				display: inline-block;
				border-radius: 4px;
				border: 1px solid #cccccc;
				position: relative;
				top: 3px;
				cursor: pointer;
		}
		
		#labelId {
				width: 18px;
				height: 18px;
				display: inline-block;
				border-radius: 4px;
				border: none;
				background-color: #025db3;
				position: relative;
				top: 3px;
				cursor: pointer;
		}
		
		#labelId:after {
				content: '';
				display: inline-block;
				border: 1px solid #ffffff;
				border-top-width: 0;
				border-right-width: 0;
				width: 10px;
				height: 7px;
				-webkit-transform: rotate(-50deg);
				position: absolute;
				top: 2px;
				left: 3px;
				cursor: pointer;
		}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue